import { supabase } from './supabase';

/**
 * Série quotidienne des commandes en ligne (RPC `daily_commissions`, sql/29).
 * Alimente le graphique « commissions Stripe — 30 derniers jours » du SuperAdmin.
 * RÉSILIENT : si la RPC n'existe pas encore (migration non lancée) ou si l'accès
 * est refusé, on renvoie une série vide → le graphe se masque sans casser la vue.
 * La commission (0,99 €/commande) est appliquée côté composant (COMMISSION_CENTS).
 */
export interface DailyPoint {
  /** Jour au format YYYY-MM-DD. */
  day: string;
  /** Nombre de commandes payées en ligne ce jour-là. */
  onlineOrders: number;
}

/** Parse la réponse jsonb de `daily_commissions` (pur, testable). */
export function parseDailyCommissions(data: unknown): DailyPoint[] {
  const obj = (data ?? {}) as { series?: { day?: string; online_orders?: number }[] };
  if (!Array.isArray(obj.series)) return [];
  return obj.series
    .map((r) => ({ day: String(r?.day ?? ''), onlineOrders: Number(r?.online_orders ?? 0) }))
    .filter((p) => p.day.length > 0 && Number.isFinite(p.onlineOrders));
}

export async function loadDailyCommissions(days = 30): Promise<DailyPoint[]> {
  const { data, error } = await supabase.rpc('daily_commissions', { p_days: days });
  if (error || !data) {
    if (error) console.warn('[daily_commissions] indisponible:', error.message);
    return [];
  }
  return parseDailyCommissions(data);
}
